import React from "react";
import { View } from "react-native";
import Button from "../../../components/Button";
import { TooltipCustom } from "../../../components/Tooltip";

import { Image } from "../style";
import { FooterText } from "../../../config/theme/globalStyles";

const ViewImage = (props) => {
    const { showModal, img, backgroundImage, orientation } = props;

    const image = backgroundImage?.url || img;

    const content = (
        <Image source={image} resizeMode="cover">
            <View
                style={{
                    backgroundColor: "rgba(0,0,0,0.7)",
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                }}
            >
                <Button
                    title={"Alterar Capa Horizontal do Módulo"}
                    onPress={() => showModal('horizontal')}
                    margin={"0.2rem"}
                ></Button>
                {orientation === 'vertical' &&
                <View style={{flexDirection: 'row', justifyContent: 'center', alignSelf: 'center'}}>
                     <Button
                       title="Alterar Capa Vertical"
                       onPress={() => showModal('vertical')}
                     />
                     <TooltipCustom 
                     iconColor={"white"}
                     text={"Os apps iOS & Android serão atualizados de acordo com nosso cronograma. A capa vertical aparecerá somente no seu App Web até a atualização"}/>
                </View>
                }
            </View>
        </Image>
    );

    return (
        <View
            style={{
                width: "100%",
                height: "100%",
                justifyContent: "center",
                borderRadius: 10,
                overflow: "hidden",
            }}
        >
            {content}
        </View>
    )
};

export default ViewImage;